import axiosOrders from '../../axios/quickOrders';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API
import router from '../../router/router';
import { store } from '../store';
// vuex module resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

// indexDB reference: https://developers.google.com/web/ilt/pwa/lab-indexeddb
import idb from 'idb';

const state = {
    merchants               : JSON.parse( localStorage.getItem( 'merchants' ) ) || [],

    quickCategories         : [],
    quickItems              : [],
    quickModifierGroups     : [],
    quickItemModifierGroups : [],

    menuVersion             : parseFloat( localStorage.getItem( 'menuVersion' ) ) || null,

    currentMenuView         : null,
    currentCategory         : null,
    currentItem             : null,
    currentItemDetails      : {

        quantity  : 1,
        modifiers : []
    },
    editingItem             : null,

    menuError               : null,
    needsMenu               : null,

    menuCached              : null
};

const mutations = {

    getOrderMenu( state, data ){

        console.log( 'data coming through..', data );
        let dbPromise = idb.open( 'quickOrdersDB', data.idbVersion );
        dbPromise.then( db => {

            if( data.body[ 'Categories' ] ){

                var txCategories;
                try {
                    txCategories = db.transaction( 'menuCategories', 'readwrite' );
                } catch( e ) {
                    store.dispatch( 'fixMissingObjectStore', e );
                }
                
                txCategories.objectStore( 'menuCategories' ).clear();
                state.quickCategories = [];
                Object.values( data.body[ 'Categories' ] ).forEach( category => {

                    state.quickCategories.push( category );
                    txCategories.objectStore( 'menuCategories' ).put( category );
                } );
            } else console.log( 'No Categories Data Returned!' );

            if( data.body[ 'Items' ] ){

                var txItems;
                try {
                    txItems = db.transaction( 'menuItems', 'readwrite' );
                } catch( e ) {
                    store.dispatch( 'fixMissingObjectStore', e );
                }

                txItems.objectStore( 'menuItems' ).clear();
                state.quickItems = [];
                Object.values( data.body[ 'Items' ] ).forEach( item => {

                    state.quickItems.push( item );
                    txItems.objectStore( 'menuItems' ).put( item );
                } );
            } else console.log( 'No Items Data Returned!' );

            if( data.body[ 'ModifierGroups' ] ){

                var txModifierGroups;
                try {
                    txModifierGroups = db.transaction( 'menuModifierGroups', 'readwrite' );
                } catch( e ) {
                    store.dispatch( 'fixMissingObjectStore', e );
                }

                txModifierGroups.objectStore( 'menuModifierGroups' ).clear();
                state.quickModifierGroups = [];
                Object.values( data.body[ 'ModifierGroups' ] ).forEach( modGroup => {

                    if ( modGroup.QuickModifierGroup.minSelect == 0 ) modGroup.isValid = true; // no validation minimum
                    else modGroup.isValid = false; // validation has a minimum requirement
                    modGroup.numSelected  = 0;
                    state.quickModifierGroups.push( modGroup );
                    txModifierGroups.objectStore( 'menuModifierGroups' ).put( modGroup );
                } );
            } else console.log( 'No Modifier Group Data Returned!' );


            if( data.body[ 'ModifierItemGroup' ] ){

                var txModifierItemGroups;
                try {
                    txModifierItemGroups = db.transaction( 'menuItemModifierGroups', 'readwrite' );
                } catch( e ) {
                    store.dispatch( 'fixMissingObjectStore', e );
                }

                txModifierItemGroups.objectStore( 'menuItemModifierGroups' ).clear();
                state.quickItemModifierGroups = [];
                Object.values( data.body[ 'ModifierItemGroup' ] ).forEach( modItemGroup => {

                    state.quickItemModifierGroups.push( modItemGroup );
                    txModifierItemGroups.objectStore( 'menuItemModifierGroups' ).put( modItemGroup );
                } );
            } else console.log( 'No Modifier Group Data Returned!' );
        });

        state.menuVersion = parseFloat( data.body.MerchantLocation.menuVersion );
        localStorage.setItem( 'menuVersion', data.body.MerchantLocation.menuVersion );

        state.currentMenuView       = 'Category';
        state.currentCategory       = null;
        state.currentItem           = null;
    },
    setMerchants( state, merchants ){

        state.merchants = merchants;
        localStorage.setItem( 'merchants', JSON.stringify( merchants ) );
    },
    chooseItem( state, itemId ){ // edit item passes the entire item object as 'itemId'

        state.currentMenuView    = 'Item';
        state.currentItem        = null;
        state.currentItemDetails = {

            quantity  : 1,
            modifiers : []
        };
        if( itemId.modifiers ){ // this is what detects if this is being called from 'editItem'

            state.currentItemDetails.quantity = itemId.quantity;
            state.editingItem                 = itemId.id;
            itemId                            = itemId.quickItemId;
        }

        for( let value of state.quickItems ){

            if( value.QuickItem.quickItemId == itemId ){

                state.currentItem = value;
                break;
            }
        }
    },
    chooseCategory( state, categoryId ){ // either set current category to null or the correct corresponding category object

        state.currentMenuView    = 'Category';
        state.currentItem        = null;
        state.currentItemDetails = {

            quantity  : 1,
            modifiers : []
        };
        if( categoryId == null ) state.currentCategory = categoryId;
        else {

            for( let category of state.quickCategories ){

                if( category.QuickCategory.quickCategoryId == categoryId ){

                    state.currentCategory = category;
                    break;
                }
            }
        }
    },
    setMenuError( state, value ){

        state.menuError = value;
    },
    clearState( state, editing ){

        if( editing == true ) state.editingItem = null;
        state.currentMenuView    = ( editing == true ) ? 'Category' : null;
        state.currentCategory    = null;
        state.currentItem        = null;
        state.currentItemDetails = {

            quantity  : 1,
            modifiers : []
        };
    },
    clearEditing( state ){ // im in an ongoing attempt to combine these two functions ( clear editing and state )

        state.editingItem        = null;
        state.currentMenuView    = 'Category';
        state.currentCategory    = null;
        state.currentItem        = null;
        state.currentItemDetails = {

            quantity  : 1,
            modifiers : []
        };
    },
    needsMenu( state ){

        state.currentMenuView         = 'Category';
        state.currentCategory         = null;
        state.currentItem             = null;
        state.quickCategories         = [];
        state.quickItems              = [];
        state.currentItemDetails = {

            quantity  : 1,
            modifiers : []
        };
        state.quickModifierGroups     = [];
        state.quickItemModifierGroups = [];

        state.menuVersion = null;
        localStorage.setItem( 'menuVersion', null );
    },
    toggleModifier( state, data ){

        // structure of data = {
        //
        //     checked : event.target.checked,
        //     modId   : modifier.quickModifierGroupId,
        //     mod     : modifier.quickModifierId,
        //     name    : modifier.name
        // }
        state.quickModifierGroups.forEach( modGroup => {

            if( data.modId == modGroup.QuickModifierGroup.quickModifierGroupId ){

                data.checked ? modGroup.numSelected++ : modGroup.numSelected--;

                if ( data.checked ) state.currentItemDetails.modifiers.push( 'group_' + data.modId + '_id_' + data.mod + '_name_' + data.name );
                else {

                    const index = state.currentItemDetails.modifiers.indexOf( 'group_' + data.modId + '_id_' + data.mod + '_name_' + data.name );
                    if( index != -1 ){

                        state.currentItemDetails.modifiers.splice( index, 1 );
                    }
                }

                if ( modGroup.QuickModifierGroup.minSelect == 0 && modGroup.QuickModifierGroup.maxSelect == 0 ){

                    modGroup.isValid = true;
                }
                else if ( modGroup.QuickModifierGroup.minSelect == 0 && modGroup.QuickModifierGroup.maxSelect > 0 ){

                    if( modGroup.numSelected <= modGroup.QuickModifierGroup.maxSelect ) modGroup.isValid = true;
                    else modGroup.isValid = false;
                }
                else if ( modGroup.QuickModifierGroup.minSelect > 0 && modGroup.QuickModifierGroup.maxSelect == 0 ){

                    if( modGroup.numSelected >= modGroup.QuickModifierGroup.minSelect ) modGroup.isValid = true;
                    else modGroup.isValid = false;
                }
                else if ( modGroup.QuickModifierGroup.minSelect > 0 && modGroup.QuickModifierGroup.maxSelect > 0 ){

                    if( modGroup.numSelected >= modGroup.QuickModifierGroup.minSelect && modGroup.numSelected <= modGroup.QuickModifierGroup.maxSelect ) modGroup.isValid = true;
                    else modGroup.isValid = false;
                }
            }
        });
    },
    updateCurrentItemDetails( state, type ){

        switch( type ){
            case 'increment':

                state.currentItemDetails.quantity++;
                break;
            case 'decrement':

                state.currentItemDetails.quantity--;
                break;
            case 'reset':
            default: // a reset if nothing specified also

                state.currentItemDetails = {

                    quantity  : 1,
                    modifiers : []
                };
                break;
        }
        if( state.currentItemDetails.quantity <= 0 ) state.currentItemDetails.quantity = 1;
    }
};

const actions = {

    getOrderMenu( { commit, getters, rootGetters, dispatch } ){


        axiosOrders({

            method: 'post',
            url: '/getMenu',
            data: qs.stringify({

                merchantId         : rootGetters[ 'merchant/currentMerchant' ].merchantId,
                merchantLocationId : rootGetters[ 'merchant/currentLocation' ].locationId,
                menuVersion        : getters.menuVersion
            })
        }).then( res => {

            console.log( ' MENU: ', res );
            if( res.data.responseCode == 100 ){

                commit( 'setMenuError', null );

                if ( res.data.data != null && res.data.data.Menu != null ){
                    // yes menu data returned - load it

                    if( getters.menuVersion != null ) console.log( rootGetters[ 'merchant/currentMerchant' ].name + ' has updated their menu, we will now load the update!' );
                    const payload = {

                        body       : res.data.data,
                        idbVersion : rootGetters[ 'idbVersion' ]
                    };
                    commit( 'getOrderMenu', payload );
                    dispatch( 'triggerTransition', null, { root: true } ); // arbitrary toggle to trigger a menu animation
                    dispatch( 'orderTab/checkAgainstNewMenu', res.data.data, { root: true } ); // see if any tab items need to be removed
                } else if ( res.data.data == 100 ) {
                    // the menu is up to date, do nothing

                } else if ( res.data.data.Menu == null ){
                    // no menu returned, which means all are offline

                    dispatch( 'updateLoadingStatus', 'Merchant has closed this Menu!', { root : true } );
                    router.replace( { name : 'merchant-location' } );
                } else dispatch( 'updateLoadingStatus', 'Menu is up to date!', { root : true } );
            } else if ( res.data.responseCode == 200 ){

                router.replace( { name : 'merchant-location' } );
                throw 'Orders have been disabled for this location!';
            } else throw 'Error loading Menu! Refresh to try again.';
        }).catch( err => {

            commit( 'setMenuError', err );
            dispatch( 'updateLoadingStatus', err, { root : true } )
        });
    },
    showLocationsBySlug( { commit, rootGetters, dispatch }, slug){
        console.log('showLocationsBySlug.. ', slug);

        axiosOrders({

            method: 'post',
            url: '/getAllMerchantsWithOrders',
            data: qs.stringify({

                test : 'seent it?'
            })
        }).then( res => {

            if( res.data.responseCode == 100 ){

                const merchants = res.data.merchants;

                let formattedMerchants = [];
                var merchantId = '';
                var merchantName = '';

                merchants.forEach( merchant => {

                    if (slug === merchant.Merchant.slug) {
                        console.log('Slug => ', slug);
                        merchantId = merchant.Merchant.merchantId;
                        merchantName = merchant.Merchant.name;
                    }

                    formattedMerchants.push( {

                        'merchantId'        : merchant.Merchant.merchantId,
                        'active'            : merchant.Merchant.active,
                        'name'              : merchant.Merchant.name,
                        'quickOrder'        : merchant.Merchant.quickOrder,
                        'slug'              : merchant.Merchant.slug
                    });
                });

                commit( 'setMerchants', formattedMerchants );


                let outCredentials = {

                    merchantId  : merchantId,
                    slug : slug,
                    name : merchantName
                };

                console.log('outCredentials => ', outCredentials);

                dispatch('auth/outAuthMerchantCredentials', outCredentials, { root: true });

            } else if( res.data.responseCode == 200 ){

                // router.replace( { name : 'merchant-location' } );
                throw 'did not connect to the API!';
            } else throw 'did not connect to the API!';
        }).catch( err => {

            // commit( 'setMenuError', err );
            dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } )
        });
    },
    grabAllMerchants( { commit, rootGetters, dispatch } ){

        console.log( 'grabbing all merchants..' );
        axiosOrders({

            method: 'post',
            url: '/getAllMerchantsWithOrders',
            data: qs.stringify({

                test : 'seent it?'
            })
        }).then( res => {

            //console.log( 'Response grabAllMerchants: ', res );
            //if( res.data.responseCode == 100 ){

                // commit( 'setMenuError', null );

                // if( getters.menuVersion != null ) console.log( rootGetters[ 'merchant/currentMerchant' ].name + ' has updated their menu, we will now load the update!' );
                // const payload = {

                //     body       : res.data.data,
                //     idbVersion : rootGetters[ 'idbVersion' ]
                // };
                // commit( 'getOrderMenu', payload );
                // dispatch( 'triggerTransition', null, { root: true } ); // arbitrary toggle to trigger a menu animation
            //} 

            //console.log( 'response: ', res );
            if( res.data.responseCode == 100 ){

                const merchants = res.data.merchants;

                let formattedMerchants = [];
                merchants.forEach( merchant => {

                    formattedMerchants.push( {

                        'merchantId'        : merchant.Merchant.merchantId,
                        'active'            : merchant.Merchant.active,
                        'name'              : merchant.Merchant.name,
                        'quickOrder'        : merchant.Merchant.quickOrder,
                        'slug'              : merchant.Merchant.slug
                    });
                });

                commit( 'setMerchants', formattedMerchants );
            } else if( res.data.responseCode == 200 ){

                // router.replace( { name : 'merchant-location' } );
                throw 'did not connect to the API!';
            } else throw 'did not connect to the API!';
        }).catch( err => {

            // commit( 'setMenuError', err );
            dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } )
        });
    },
    chooseCategory( { commit, getters, dispatch }, categoryId ){

        commit( 'chooseCategory', categoryId );
        dispatch( 'triggerTransition', null, { root: true } ); // arbitrary toggle to trigger a menu animation
    },
    chooseItem( { commit }, itemId ){

        commit( 'chooseItem', itemId );
    },
    updateCurrentItemDetails( { commit }, type ){

        commit( 'updateCurrentItemDetails', type );
    },
    editItem( { commit }, item ){

        item.modifiers.forEach( mod => {

            let splitMod = mod.split( "_" );
            const editData = {

                checked : true,
                modId   : parseInt( splitMod[ 1 ], 10 ),
                mod     : parseInt( splitMod[ 3 ], 10 ),
                name    : splitMod[ 5 ]
            }
            if( splitMod[ splitMod.length - 1 ] != 'unavailable' ) commit( 'toggleModifier', editData );
        });
    },
    clearState( { commit }, editing = false ){

        commit( 'clearState', editing );
    },
    clearEditing( { commit } ){

        commit( 'clearEditing' );
    },
    needsMenu( { commit, getters, dispatch } ){

        commit( 'clearEditing'  ); // no 'editing' item
        commit( 'needsMenu'     ); // some redundancy with clearState, also removes menu state items
        commit( 'clearState'    ); // no 'current' anything
        dispatch( 'merchant/clearData', null, { root: true } ); // removes locations and current location
    },
    changeLocation( { commit } ){

        commit( 'clearEditing' ); // no 'editing' item
        commit( 'needsMenu'    ); // some redundancy with clearState, also removes menu state items
    },
    toggleModifier( { commit }, data ){

        commit( 'toggleModifier', data );
    }
};

const getters = {

    allMerchants       : state => state.merchants,
    menuCached         : state => state.menuCached,
    menuVersion        : state => state.menuVersion,
    currentMenuView    : state => state.currentMenuView, // is either null or a string value ( 'Category' or 'Item' are only options as of now )
    currentCategory    : state => state.currentCategory, // is either null or a category object
    currentItem        : state => state.currentItem, // is either null or an item object
    currentItemDetails : state => state.currentItemDetails,
    parentCategoryId( getters ){ // either return the current category's parent Id or null

        if( getters.currentCategory == null ){ // no current category means we're at Root Level

            return null;
        } else if ( getters.currentItem != null ){

            return getters.currentCategory.QuickCategory.quickCategoryId;
        } else {

            return getters.currentCategory.QuickCategory.parentCategoryId;
        }
    },
    relevantCategories( state, getters ){ // either return the categories array or null

        let relevantCategories = [];
        state.quickCategories.forEach( value => {

            if( !value.QuickCategory.deleted && value.QuickCategory.parentCategoryId == ( getters.currentCategory == null ? null : getters.currentCategory.QuickCategory.quickCategoryId ) ){

                relevantCategories.push( value );
            }
        });

        if( relevantCategories.length >= 1 ){

            relevantCategories.sort( ( a, b ) => a.QuickCategory.sequenceOfDisplay - b.QuickCategory.sequenceOfDisplay );
        } else relevantCategories = null;

        return relevantCategories;
    },
    relevantItems( state, getters ){ // either return the items array or null

        let relevantItems = [];

        state.quickItems.forEach( value => {

            if( !value.QuickItem.deleted && value.QuickItem.quickCategoryId == ( getters.currentCategory == null ? null : getters.currentCategory.QuickCategory.quickCategoryId ) ){

                relevantItems.push( value );
            }
        });
        if( relevantItems.length >= 1 ){

            relevantItems.sort( ( a, b ) => a.QuickItem.sequenceOfDisplay - b.QuickItem.sequenceOfDisplay );
        } else relevantItems = null;

        return relevantItems;
    },
    relevantModifierGroups( state, getters ){ // either return modifierGroup array or null

        let relevantModifierGroups = [];
        if( getters.currentItem == null ){ // no current item means no modifiers needed

            return null;
        } else {

            // console.log( 'calculating relevant mod groups...' );
            state.quickItemModifierGroups.forEach( value => {

                if( value.QuickItemModifierGroup.quickItemId == getters.currentItem.QuickItem.quickItemId ){

                    for( let group of state.quickModifierGroups ){

                        if( group.QuickModifierGroup.quickModifierGroupId == value.QuickItemModifierGroup.quickModifierGroupId ){

                            if( group.QuickModifierGroup.deleted ) break;
                            else {

                                group.numSelected = 0; // this was being called in a different timing on local vs dev, causing hard-to-track problems
                                // console.log( 'set numSelected to zero lol' );

                                if ( group.QuickModifierGroup.minSelect == 0 && group.QuickModifierGroup.maxSelect == 0 ) group.isValid = true;
                                else if ( group.QuickModifierGroup.minSelect == 0 && group.QuickModifierGroup.maxSelect > 0 ){

                                    group.isValid = true;
                                }
                                else if ( group.QuickModifierGroup.minSelect > 0 && group.QuickModifierGroup.maxSelect == 0 ){

                                    group.isValid = false;
                                }
                                else if ( group.QuickModifierGroup.minSelect > 0 && group.QuickModifierGroup.maxSelect > 0 ){

                                    group.isValid = false;
                                }

                                group.sequenceOfDisplay = value.QuickItemModifierGroup.sequenceOfDisplay;
                                relevantModifierGroups.push( group );
                                break;
                            }
                        }
                    }
                }
            });

            if( relevantModifierGroups.length >= 1 ){

                relevantModifierGroups.sort( ( a, b ) => parseInt( a.sequenceOfDisplay ) - parseInt( b.sequenceOfDisplay ) );
                relevantModifierGroups.forEach( group => {

                    console.log( group );
                    let relevantModifiers = Object.values( group.QuickModifier ).filter( mod => !mod.deleted );
                    let sortedModifiers = relevantModifiers.sort( ( a, b ) => {

                        return parseInt( a.sequenceOfDisplay ) - parseInt( b.sequenceOfDisplay );
                    });
                    group.QuickModifier = { ...sortedModifiers };
                });
            } else relevantModifierGroups = null;

            return relevantModifierGroups;
        }
    },
    allModifiersValid( state, getters ){

        let numValid = 0;
        if( getters.relevantModifierGroups == null ) return true;
        getters.relevantModifierGroups.forEach( modGroup => {

            modGroup.isValid = false;
            if ( modGroup.QuickModifierGroup.minSelect == 0 && modGroup.QuickModifierGroup.maxSelect == 0 ){

                modGroup.isValid = true;
                numValid++;
            } else if ( modGroup.QuickModifierGroup.minSelect == 0 && modGroup.QuickModifierGroup.maxSelect > 0 ){

                if( modGroup.numSelected <= modGroup.QuickModifierGroup.maxSelect ){

                    modGroup.isValid = true;
                    numValid++;
                }
            }
            else if ( modGroup.QuickModifierGroup.minSelect > 0 && modGroup.QuickModifierGroup.maxSelect == 0 ){

                if( modGroup.numSelected >= modGroup.QuickModifierGroup.minSelect ){

                    modGroup.isValid = true;
                    numValid++;
                }
            }
            else if ( modGroup.QuickModifierGroup.minSelect > 0 && modGroup.QuickModifierGroup.maxSelect > 0 ){

                if( modGroup.numSelected >= modGroup.QuickModifierGroup.minSelect && modGroup.numSelected <= modGroup.QuickModifierGroup.maxSelect ){

                    modGroup.isValid = true;
                    numValid++;
                }
            }
        });

        return ( numValid == getters.relevantModifierGroups.length ) ? true : false;
    },
    getMenuError     : state => state.menuError,
    needsMenu        : state => state.needsMenu,
    editingItem      : state => state.editingItem
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};